import { useEffect, useRef } from 'react'

import { searchPageStore } from 'Pods/SearchPage/Store/index'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { SEARCH_EVENT_SOURCE } from 'Pods/Shared/UserTracker/UserTracker'

import { getFiltersSelected, trackResultsCount, trackSearchContent } from './searchPageTracker'

const getWithinKeyword = (state = searchPageStore.getState()) => (state.keyword || '').trim()

/**
 * results_count for every result set the page shows (the server-rendered one included, zero
 * results too) and search_content whenever a filter change produced it. Paging keeps the filters,
 * so it only reports results_count.
 */
export default function useResultSetTracking() {
  const pageConfig = usePageConfig()
  const hasTrackedLandingRef = useRef(false)

  useEffect(() => {
    let reportedFilters = getFiltersSelected()
    let reportedKeyword = getWithinKeyword()

    return searchPageStore.subscribe((state, previousState) => {
      // meta is rewritten only when a fetch lands (Store/actions/results.js), never while loading.
      if (state.meta === previousState.meta) {
        return
      }

      // A set that lands first replaces the server-rendered one, which then goes unreported.
      hasTrackedLandingRef.current = true
      const filters = getFiltersSelected(state)
      if (filters !== reportedFilters) {
        const keyword = getWithinKeyword(state)
        // A new "Search within results" term is a search from the results page; clearing it is not.
        const isWithinSearch = keyword !== '' && keyword !== reportedKeyword
        reportedFilters = filters
        reportedKeyword = keyword
        trackSearchContent({ eventSource: isWithinSearch ? SEARCH_EVENT_SOURCE.SEARCH_PAGE : undefined })
      }
      trackResultsCount()
    })
  }, [])

  // The experiment attributes arrive with /load-services.js, so the server-rendered result set is
  // reported once that script has landed rather than on mount.
  const isServicesLoaded = Boolean(pageConfig?.servicesLoaded)

  useEffect(() => {
    if (!isServicesLoaded || hasTrackedLandingRef.current) {
      return
    }
    hasTrackedLandingRef.current = true
    trackResultsCount()
  }, [isServicesLoaded])
}
